import React from 'react';
import { useSetupAnalyticsClient, useSetupApolloClient } from '@atlassian/ptc-common';
import { setEnv } from '@atlassian/teams-common/context-config';
import App from './components/App';
const EmbeddableDirectory = props => {
  const {
    addFlag,
    appName,
    contextSpaPaths,
    contextEntryPoint,
    locale,
    push,
    replace,
    docTitle,
    statusCodeHandlers,
    env,
    history,
    isSentryEnabled = true,
    cloudId,
    orgId,
    teamCentralHandlers,
    subProduct,
    productFeatureFlags,
    invitePeopleHandlers
  } = props;
  if (env) {
    setEnv(env);
  }
  const analyticsClient = useSetupAnalyticsClient(cloudId, appName, subProduct);
  const apolloClient = useSetupApolloClient(cloudId);
  if (!analyticsClient) {
    return null;
  }
  return /*#__PURE__*/React.createElement(App, {
    apolloClient: apolloClient,
    analytics: analyticsClient,
    appName: appName,
    contextSpaPaths: contextSpaPaths,
    contextEntryPoint: contextEntryPoint,
    env: env,
    push: push,
    replace: replace,
    addFlag: addFlag,
    locale: locale,
    docTitle: docTitle,
    statusCodeHandlers: statusCodeHandlers,
    history: history,
    cloudId: cloudId,
    orgId: orgId,
    teamCentralHandlers: teamCentralHandlers,
    skipI18nProvider: false,
    productFeatureFlags: productFeatureFlags,
    invitePeopleHandlers: invitePeopleHandlers,
    isSentryEnabled: isSentryEnabled
  });
};
export default EmbeddableDirectory;
export { useCollaboratorsQuery } from './components/Collaborators';